import React from 'react';
import { useTranslation } from 'react-i18next';
import SystemStatusDashboard from '../components/SystemStatusDashboard';
import SciFiBackground from '../components/SciFiBackground/SciFiBackground';
import Navbar from '../components/Navigation/Navbar';
import PlatformPageHeader from '../components/Common/PlatformPageHeader';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import { Box, Container } from '@mui/material';

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <SciFiBackground>
      <Navbar />
      <Box component="main" sx={{ minHeight: 'calc(100vh - 72px)', py: { xs: 5, md: 8 }, px: 2 }}>
        <Container maxWidth="xl">
          <PlatformPageHeader
            icon={DashboardCustomizeRoundedIcon}
            eyebrow="VITRIA / SYSTEM"
            title={t('installationSystemStatus')}
            subtitle={t('monitorSystemDuringInstallation')}
          />
          <SystemStatusDashboard />
        </Container>
      </Box>
    </SciFiBackground>
  );
};

export default Dashboard;
